import { useSelector } from 'react-redux'
import { useExportResourceModal } from 'components/modals/common/ExportResourceModal/hooks'
import { useModal } from 'hooks'
import { getFileName } from 'utils/sheet'
import { percentScore } from 'utils/stringFormat'
import { getOrm } from 'orm/selectors'

export const useExportCandidateGroupState = () => {
  const { candidates } = useSelector(getOrm)

  const fileName = getFileName('candidates')

  const pks = Object.keys(candidates?.meta?.selected ?? {})
  const items = candidates?.items

  const data = pks
    .filter(pk => pk in items)
    .map(pk => {
      const candidate = items[pk]
      const scores = candidate?.scores ?? {}

      return {
        name: candidate?.name,
        email: candidate?.email,
        phone: candidate?.phone,
        gma_score: percentScore(scores.GMA, ''),
        personality_score: percentScore(scores.Personality, ''),
        test_score: percentScore(scores['Ebber Test Score'], ''),
        interview_score: percentScore(scores.Interview, ''),
        final_score: percentScore(scores['Ebber Final Score'], ''),
      }
    })

  const { handleExportFile } = useExportResourceModal({ data })

  const handleExportCSV = handleExportFile(`${fileName}.csv`)

  const handleExportXLXS = handleExportFile(`${fileName}.xlsx`)

  return {
    state: { data },
    handlers: { handleExportCSV, handleExportXLXS },
  }
}

export const useExportCandidateGroupModal = () => {
  const { handleClose, handleOpen, isOpen } = useModal()

  return {
    handleExportCandidateGroupModalClose: handleClose,
    handleExportCandidateGroupModalOpen: handleOpen,
    isExportCandidateGroupModalOpen: isOpen,
  }
}
